import { useApiClient } from '../../api/useApiClient';

class ReindexService {
    constructor(apiClient) {
        this.apiClient = apiClient;
    }

    startReindex() {
        return this.apiClient.post('/api/v1/admin/reindex');
    }

    getReindexStatus() {
        return this.apiClient.get('/api/v1/admin/reindex/status');
    }
}

export const useReindexService = () => {
    const apiClient = useApiClient();
    return new ReindexService(apiClient);
};

// Backward compatibility alias
export const useIndexService = useReindexService;

export default ReindexService;
